import { takeEvery, fork, put, all, call } from "redux-saga/effects"
import toastr from "toastr"

// Login Redux States
import { EDIT_PROFILE, PASSWORD_CHANGE, VIEW_PROFILE } from "./actionTypes"
import { profileSuccess, profileError, viewProfileSuccess, viewProfileError } from "./actions"

import {
  onPasswordChange,
  onProfileUpdate, onProfileView,
} from "helpers/backend_api_helper"

function* viewProfile({ payload: { url, callback } }) {
  try {
    const response = yield call(onProfileView, url, callback)
    callback && callback(response)
    yield put(profileSuccess(response))

  } catch (error) {
    yield put(profileError(error))
  }
}

function* editProfile({ payload: { user, url, callback } }) {
  try {
    const response = yield call(onProfileUpdate, user, url);
    yield put(profileSuccess(response));

    callback && callback(response);
  } catch (error) {
    yield put(profileError(error))
  }
}

function* passwordChange({ payload: { data, url, callback } }) {
  try {
    const response = yield call(onPasswordChange, data, url);
    yield put(profileSuccess(response));

    callback && callback(response);
  } catch (error) {
    toastr.error(error?.response?.data?.message || "Server Error")
    yield put(profileError(error))
  }
}

export function* watchProfile() {
  yield takeEvery(EDIT_PROFILE, editProfile)
  yield takeEvery(VIEW_PROFILE, viewProfile)
  yield takeEvery(PASSWORD_CHANGE, passwordChange)
}

function* ProfileSaga() {
  yield all([fork(watchProfile)])
}

export default ProfileSaga
